import Navbar from '../components/Home/Navbar';
import Footer from '../components/Home/Footer';
import Contact from '../components/Home/Contact';
import ServiceA from '../components/Home/Servicios-A';
import ServiceB from '../components/Home/Servicios-B';
import Customers from '../components/Home/Customers';
import Coverage from '../components/Home/Cobertura';

export default function Nosotros() {
	return (
		<header>
			<Navbar />
			<ServiceA />
			<Customers />
			<ServiceB />
			<Coverage />
			<Contact />
			<Footer />
		</header>
	);
}
